/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_MelanesiaInputs */

const bn_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মেলানেশিয়া`)
};

const de_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melanesien`)
};

const el_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μελανησία`)
};

const en_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melanesia`)
};

const es_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`melanesia`)
};

const fr_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mélanésie`)
};

const hi_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेलानेशिया`)
};

const hu_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melanézia`)
};

const id_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melanesia`)
};

const it_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melanesia`)
};

const ja_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メラネシア`)
};

const ko_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`멜라네시아`)
};

const nl_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melanesië`)
};

const pl_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melanezja`)
};

const pt_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melanésia`)
};

const ru_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Меланезия`)
};

const sv_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melanesia`)
};

const tr_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melanezya`)
};

const uk_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Меланезія`)
};

const vi_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melanesia`)
};

const zh_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`美拉尼西亚`)
};

const zh_hant_geo_label_melanesia = /** @type {(inputs: Geo_Label_MelanesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`美拉尼西亞`)
};

/**
* | output |
* | --- |
* | "Melanesia" |
*
* @param {Geo_Label_MelanesiaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_melanesia = /** @type {((inputs?: Geo_Label_MelanesiaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_MelanesiaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_melanesia(inputs)
	if (locale === "de") return de_geo_label_melanesia(inputs)
	if (locale === "el") return el_geo_label_melanesia(inputs)
	if (locale === "en") return en_geo_label_melanesia(inputs)
	if (locale === "es") return es_geo_label_melanesia(inputs)
	if (locale === "fr") return fr_geo_label_melanesia(inputs)
	if (locale === "hi") return hi_geo_label_melanesia(inputs)
	if (locale === "hu") return hu_geo_label_melanesia(inputs)
	if (locale === "id") return id_geo_label_melanesia(inputs)
	if (locale === "it") return it_geo_label_melanesia(inputs)
	if (locale === "ja") return ja_geo_label_melanesia(inputs)
	if (locale === "ko") return ko_geo_label_melanesia(inputs)
	if (locale === "nl") return nl_geo_label_melanesia(inputs)
	if (locale === "pl") return pl_geo_label_melanesia(inputs)
	if (locale === "pt") return pt_geo_label_melanesia(inputs)
	if (locale === "ru") return ru_geo_label_melanesia(inputs)
	if (locale === "sv") return sv_geo_label_melanesia(inputs)
	if (locale === "tr") return tr_geo_label_melanesia(inputs)
	if (locale === "uk") return uk_geo_label_melanesia(inputs)
	if (locale === "vi") return vi_geo_label_melanesia(inputs)
	if (locale === "zh") return zh_geo_label_melanesia(inputs)
	return zh_hant_geo_label_melanesia(inputs)
});